import React from 'react'
import { Title } from 'components/misc'
import { Header, LayoutPlain } from 'components/layout'
import { meta } from 'helpers/decorators'

export default meta({
  title: 'Participant registration fees payment',
  intlKey: 'moduleTitle.payment'
})(() => {
  return (
    <LayoutPlain greyBg header={<Header />}>
      <Title h1 intlKey="moduleTitle.payment" className="base-margin--top">
        Participant registration fees payment
      </Title>
      <Title h3 intlKey="label.problem_with_payment">
        There was a problem processing your payment. Please contact your
        National Award Operator (NAO).
      </Title>
    </LayoutPlain>
  )
})
